<script setup lang="ts">
// Standalone page wrapper: the routes list is normally a tab of the home
// bottom sheet, but the route-list URL is kept for existing deep links.
import RoutesContent from './index.vue';
import { useAppStore } from '@/stores/app';

const appStore = useAppStore();
</script>

<template>
  <div class="page" :class="{ 'page--no-navbar': appStore.shouldHideNavbar }">
    <div class="content">
      <RoutesContent />
    </div>
  </div>
</template>
